document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[aria-controls=site-menu]');
  const pages = document.querySelectorAll('.site-menu__pages > li');
  const nav = document.querySelector('.site-menu');
  const header = document.querySelector('.site-header');
  const topBar = document.querySelector('.site-top-bar');
  // const searchButton = document.querySelector('[aria-controls=search]');
  // const searchForm = document.querySelector('#header-search-form');
  const main = document.querySelector('#main');
  const bg = document.querySelector('.site-menu__bg');
  const menuDelayCap = 70;
  const menuInDelayCap = 70;
  const menuOutDelayCap = 100;
  let menuInterval = null;
  let menuDelay = 0;
  let menuActive = false;
  const navBreakpoint = 1100;

  function devLog(msg) {
    // console.log(msg);
  }

  function isTouchDevice() {
    return Boolean(
      'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
    );
  }

  if (menuButton) {
    menuButton.addEventListener('click', () => {
      // main.classList.remove('is-search-open');
      // main.classList.toggle('is-menu-open');
      if (isMenuOpen()) {
        main.classList.remove('is-menu-open');
      } else if (main.classList.contains('is-search-open')) {
        main.classList.remove('is-search-open');
      } else {
        main.classList.add('is-menu-open');
      }
    });
  }

  function isMenuOpen() {
    return main.classList.contains('is-menu-open') === true;
  }

  // When the escape key is pressed, close the menu.
  document.addEventListener('keydown', (e) => {
    if (isMenuOpen() && e.key === 'Escape') {
      main.classList.remove('is-menu-open');
      nav.classList.remove('is-expanded');
      pages.forEach((page) => {
        const active = false;
        if (page.hasAttribute('aria-expanded')) {
          page.setAttribute('aria-expanded', String(active));
          page
            .querySelector(':scope > .site-menu__section')
            .setAttribute('aria-hidden', String(!active));
          page.querySelector(':scope > .site-menu__section').hidden = !active;
        }
      });
      clearInterval(menuInterval);
      menuDelay = 0;
    }
  });

  // if (searchButton) {
  //   searchButton.addEventListener('click', (e) => {
  //     const active = true;
  //     searchButton.setAttribute('aria-expanded', String(active));
  //     searchButton.setAttribute('aria-hidden', String(active));
  //     searchButton.hidden = active;
  //     searchForm.setAttribute('aria-expanded', String(active));
  //     searchForm.setAttribute('aria-hidden', String(!active));
  //     searchForm.hidden = !active;
  //     searchForm.querySelector('input').focus();
  //     e.preventDefault();
  //   });
  // }

  pages.forEach((el) => {
    const resizeBg = () => {
      let height = el.querySelector(
        ':scope > .site-menu__section'
      ).offsetHeight;
      if (header) height += header.offsetHeight;
      if (topBar && topBar.offsetHeight) height += topBar.offsetHeight;
      if (topBar && !topBar.hidden) height += topBar.offsetHeight;
      bg.style.height = height + 'px';
    };

    const toggle = (e) => {
      clearInterval(menuInterval);
      menuDelay = 0;

      const active = !(
        e.target.closest('.site-menu__li').getAttribute('aria-expanded') ===
        'true'
      );
      el.setAttribute('aria-expanded', String(active));
      el.querySelector(':scope > .site-menu__section').setAttribute(
        'aria-hidden',
        String(!active)
      );
      el.querySelector(':scope > .site-menu__section').hidden = !active;
      if (active) main.classList.add('is-menu-expanded');
      else main.classList.remove('is-menu-expanded');

      e.preventDefault();
      return false;
    };

    const toggleViaBtn = (e) => {
      clearInterval(menuInterval);
      menuDelay = 0;
      devLog('toggleViaBtn');
      if (
        e.target.closest('.site-menu').getAttribute('aria-expanded') === 'true'
      ) {
        contract();
        devLog('contract');
      } else {
        expand();
        devLog('expand');
      }
      e.preventDefault();
      return false;
    };

    const contract = () => {
      main.classList.remove('is-menu-open');
      main.classList.remove('is-menu-expanded');
      nav.classList.remove('is-expanded');

      pages.forEach((page) => {
        const active = false;
        if (page.hasAttribute('aria-expanded')) {
          page.setAttribute('aria-expanded', String(active));
          page
            .querySelector(':scope > .site-menu__section')
            .setAttribute('aria-hidden', String(!active));
          page.querySelector(':scope > .site-menu__section').hidden = !active;

          page
            .querySelector(':scope > .site-menu__section')
            .classList.remove('is-visible');
        }
      });

      // if (searchButton) {
      //   searchButton.setAttribute('aria-expanded', String(false));
      //   if (el.hasAttribute('aria-expanded')) {
      //     el.setAttribute('aria-expanded', false);
      //     el.querySelector(':scope > .site-menu__section').setAttribute(
      //       'aria-hidden',
      //       true
      //     );
      //     el.querySelector(':scope > .site-menu__section').hidden = true;
      //   }
      // }
    };

    const expand = () => {
      devLog('expand');
      clearInterval(menuInterval);
      menuDelay = 0;

      main.classList.add('is-menu-open');
      devLog('is-menu-open');
      main.classList.add('is-menu-expanded');
      nav.classList.add('is-expanded');

      pages.forEach((page) => {
        const active = page === el;
        if (page.hasAttribute('aria-expanded')) {
          page.setAttribute('aria-expanded', String(active));
          page
            .querySelector(':scope > .site-menu__section')
            .setAttribute('aria-hidden', String(!active));
          page.querySelector(':scope > .site-menu__section').hidden = !active;

          if (active) {
            setTimeout(() => {
              page
                .querySelector(':scope > .site-menu__section')
                .classList.add('is-visible');
            }, 1);
          }
        }
      });

      resizeBg();
    };

    const hoverIf = (condition, e) => {
      devLog('hoverIf');
      if (condition(e)) {
        expandDelay(e);
      }
    };

    const leaveA = () => {
      clearInterval(menuInterval);
      menuDelay = 0;
    };

    const leave = () => {
      clearInterval(menuInterval);
      menuDelay = 0;
    };

    const expandDelay = (e) => {
      clearInterval(menuInterval);
      menuDelay = isMenuOpen() ? menuDelayCap : menuInDelayCap;
      menuInterval = setInterval(() => {
        if (menuDelay > 0) {
          menuDelay -= 1;
          if (menuDelay <= 0) {
            if (e.target.parentNode.hasAttribute('aria-expanded')) {
              expand();
            } else {
              contract();
            }
          }
        }
      }, 1);
    };

    const expandIf = (condition, e) => {
      const hasChildren = e.target
        .closest('.site-menu__li')
        .hasAttribute('aria-expanded');

      if (condition(e)) {
        devLog('toggle');
        toggle(e);
      }

      // Parent items open a submenu instead of navigating.
      // Leaf items (no children) should follow their href.
      if (hasChildren && window.matchMedia('(min-width: 1201px)').matches) {
        e.preventDefault();
      }
    };

    const expandHoverIf = (condition, e) => {
      if (condition(e) && (menuDelay <= 0 || !isMenuOpen())) {
        if (e.target.parentNode.hasAttribute('aria-expanded')) {
          expandDelay(e);
        } else {
          contract();
        }
        e.preventDefault();
      }
    };

    const contractIf = (condition, e) => {
      if (condition(e)) {
        clearInterval(menuInterval);
        menuDelay = menuOutDelayCap;
        menuInterval = setInterval(() => {
          if (menuDelay > 0) {
            menuDelay -= 1;
            if (menuDelay <= 0 && !menuActive) {
              devLog(menuActive);
              devLog('contracted');
              contract();
              e.preventDefault();
            }
          }
        }, 1);
      }
    };

    const bgEnter = () => {
      devLog('bgEnter');
      menuActive = true;
    };

    const bgLeave = () => {
      devLog('bgLeave');
      menuActive = false;
    };

    const expandIfMobile = expandIf.bind(undefined, (e) => {
      return (
        window.matchMedia('(max-width: ' + navBreakpoint + 'px)').matches &&
        e.target.closest('.site-menu__li').hasAttribute('aria-expanded')
      );
    });

    const hoverIfDesktop = hoverIf.bind(undefined, (e) => {
      return window.matchMedia('(min-width: ' + navBreakpoint + 'px)').matches;
    });

    const expandHoverIfDesktop = expandHoverIf.bind(undefined, (e) => {
      return window.matchMedia('(min-width: ' + navBreakpoint + 'px)').matches;
    });

    const contractIfDesktop = contractIf.bind(undefined, (e) => {
      return window.matchMedia('(min-width: ' + navBreakpoint + 'px)').matches;
    });

    const back = el.querySelector('.site-menu__back');
    if (back) {
      back.addEventListener('click', () => {
        main.classList.remove('is-menu-expanded');
        nav.classList.remove('is-expanded');
        el.setAttribute('aria-expanded', 'false');
        el.querySelector('.site-menu__section').setAttribute(
          'aria-hidden',
          String(true)
        );
        el.querySelector('.site-menu__section').hidden = true;
      });
    }

    const closeButton = el.querySelector('.site-menu__close');
    if (closeButton) {
      closeButton.addEventListener('click', contract);
    }

    // const toggleButton = el.querySelector('.site-menu__link-toggle');
    // if (toggleButton) {
    //   toggleButton.addEventListener('click', toggleViaBtn);
    // }

    const a = el.querySelector('.site-menu__link');
    a.addEventListener('click', expandIfMobile);
    a.addEventListener('mouseleave', leaveA);
    nav.addEventListener('mouseleave', leave);

    bg.addEventListener('mouseenter', bgEnter);
    bg.addEventListener('mouseleave', bgLeave);

    a.addEventListener('mouseenter', hoverIfDesktop);
    a.addEventListener('mouseenter', expandHoverIfDesktop);
    nav.addEventListener('mouseleave', contractIfDesktop);

    contract();
  });

  // detect current sections and pages
  if (typeof setCurrentPage !== 'undefined' && setCurrentPage) {
    const link = document.querySelector(
      '.site-menu__child-link[data-id="' + setCurrentPage + '"]'
    );
    if (link) {
      link.classList.add('site-menu__child-link--active');
    }
  }

  if (typeof setCurrentSection !== 'undefined' && setCurrentSection) {
    // const section = document.querySelector(
    //   '.site-menu__li[data-id="' + setCurrentSection + '"]'
    // );
    // const active = true;
    // if (section && !isTouchDevice()) {
    //   section.setAttribute('aria-expanded', String(active));
    //   section
    //     .querySelector(':scope > .site-menu__section')
    //     .setAttribute('aria-hidden', String(!active));
    //   section.querySelector(':scope > .site-menu__section').hidden = !active;
    // }
    const link = document.querySelector(
      '.site-menu__link[data-id="' + setCurrentSection + '"]'
    );
    if (link) {
      link.classList.add('site-menu__link--active');
    }
  }

  document.querySelectorAll('.site-menu__dropdown').forEach((dropdown) => {
    const items = dropdown.querySelectorAll('.site-menu__dropdown-item');

    const reset = () => {
      dropdown.classList.remove('is-drilled');
      items.forEach((item) => {
        item.classList.remove('is-open');
        const parentLink = item.querySelector(
          ':scope > .site-menu__dropdown-link'
        );
        const children = item.querySelector(
          '.site-menu__dropdown-item-children'
        );
        if (parentLink && parentLink.hasAttribute('aria-expanded')) {
          parentLink.setAttribute('aria-expanded', 'false');
        }
        if (children) children.hidden = true;
      });
    };

    items.forEach((item) => {
      const parentLink = item.querySelector(
        ':scope > .site-menu__dropdown-link'
      );
      const children = item.querySelector('.site-menu__dropdown-item-children');
      const back = item.querySelector('.site-menu__dropdown-back');

      if (!parentLink || !children) return;

      parentLink.addEventListener('click', (e) => {
        e.preventDefault();
        reset();
        item.classList.add('is-open');
        dropdown.classList.add('is-drilled');
        parentLink.setAttribute('aria-expanded', 'true');
        children.hidden = false;
        if (back) back.focus();
      });

      if (back) {
        back.addEventListener('click', () => {
          reset();
          parentLink.focus();
        });
      }
    });

    const li = dropdown.closest('.site-menu__li');
    if (li) {
      li.addEventListener('mouseleave', reset);
    }

    dropdown.addEventListener('focusout', (e) => {
      if (!dropdown.contains(e.relatedTarget)) {
        reset();
      }
    });
  });
});
